
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $lyoVb = parcelRequire("lyoVb");
function $a6191b1e8a5bb6cc$export$de27182ff8187d6c() {
    (0, $lyoVb.setupCommon)();
}
const $a6191b1e8a5bb6cc$var$count = 40;
const $a6191b1e8a5bb6cc$var$prev = [];
function $a6191b1e8a5bb6cc$export$e529deb2bfd496dc() {
    (0, $lyoVb.drawCommon)();
    background(98);
    if ($a6191b1e8a5bb6cc$var$prev.length > $a6191b1e8a5bb6cc$var$count - 1) $a6191b1e8a5bb6cc$var$prev.shift();
    if ($a6191b1e8a5bb6cc$var$prev.length < $a6191b1e8a5bb6cc$var$count) for(let i = 0; i < $a6191b1e8a5bb6cc$var$count - $a6191b1e8a5bb6cc$var$prev.length; i++){
        const ls = [];
        for(let y = 0.05; y < 1; y += 0.05){
            const l = [];
            for(let x = 0.02; x < 0.99; x += 0.01){
                const z = (0, $lyoVb.frameN) * 6 + i * 0.01;
                const n = (noise(x * 4.9 + 2 * Math.cos((0, $lyoVb.frameN) * TAU), y * 3.1, z) * 2 - 1) * 0.09;
                let y2 = y + n * (0, $lyoVb.smoothstep)(0, 0.9, y) * x * x * 2;
                l.push([
                    x,
                    y2
                ]);
            }
            ls.push(l);
        }
        $a6191b1e8a5bb6cc$var$prev.push(ls);
    }
    const sat = 80 + 8 * Math.sin((0, $lyoVb.frameN) * TAU + PI);
    const bri = 70 + 5 * Math.sin((0, $lyoVb.frameN) * TAU + HALF_PI);
    noFill();
    $a6191b1e8a5bb6cc$var$prev.forEach((ls)=>{
        ls.forEach((l, j)=>{
            const hue = 190 + 20 * Math.sin((0, $lyoVb.frameN) * TAU + j * 0.08);
            stroke(hue, sat, bri, 0.2);
            beginShape();
            l.forEach(([x, y])=>vertex((0, $lyoVb.w)(x), (0, $lyoVb.h)(y)));
            endShape();
        });
    });
}



var $gPx2I = parcelRequire("gPx2I");
parcelRequire("d3dEA");
const $a78f52583ba3c0fe$var$source = "import {\n  easeInOutSine,\n  smoothstep,\n  clamp,\n  w, h,\n  frame,\n  frameN,\n  setFrameN,\n  getCanvasSize,\n  setupCommon,\n  drawCommon,\n  make,\n} from '../js/common.js';\n\nexport function setup() {\n	setupCommon();\n}\n\nconst count = 40;\nconst prev = [];\nexport function draw() {\n	drawCommon();\n	background(98);\n\n	if (prev.length > count - 1)\n		prev.shift();\n\n	if (prev.length < count) {\n		for (let i = 0; i < count - prev.length; i++) {\n			const ls = [];\n			for (let y = 0.05; y < 1; y += 0.05) {\n				const l = [];\n				for (let x = 0.02; x < 0.99; x += 0.01) {\n					const z = frameN * 6 + i * 0.01;\n					const n = (noise(x * 4.9 + 2 * Math.cos(frameN * TAU), y * 3.1, z) * 2 - 1) * 0.09;\n					let y2 = y + n * smoothstep(0, 0.9, y) * x * x * 2;\n					l.push([x, y2]);\n				}\n				ls.push(l);\n			}\n			prev.push(ls);\n		}\n	}\n\n\n	const sat = 80 + 8 * Math.sin(frameN * TAU + PI);\n	const bri = 70 + 5 * Math.sin(frameN * TAU + HALF_PI);\n	noFill();\n	prev.forEach(ls => {\n		ls.forEach((l, j) => {\n			const hue = 190 + 20 * Math.sin(frameN * TAU + j * 0.08);\n			stroke(hue, sat, bri, 0.2);\n\n			beginShape();\n			l.forEach(([x, y]) => vertex(w(x), h(y)));\n			endShape();\n		});\n	});\n}\n";
(0, $gPx2I.make)({
    setup: $a6191b1e8a5bb6cc$export$de27182ff8187d6c,
    draw: $a6191b1e8a5bb6cc$export$e529deb2bfd496dc
}, $a78f52583ba3c0fe$var$source);


//# sourceMappingURL=06.5e21ed5a.js.map
